import { StyleSheet } from 'aphrodite/no-important';
import { color, fontWeight } from '../../shared/styles/vars';
import { media } from '../../shared/styles/constants';

export const styles = StyleSheet.create({

    fsVideoDetails: {
        margin: '25px 20px 20px',

        [media.MOBILE]: {
            margin: 0,
            width: '70%'
        },
        [media.TABLET]: {
            width: '95%'
        }
    },

    headline: {
        color: color.white,
        fontSize: 8,
        [media.MOBILE]: {
            fontSize: 7,
            width: 150,
            paddingBottom: 10,
            wordWrap: 'break-word',
            overflow: 'hidden',
            maxHeight: '9em',
            lineHeight: '3em',
        },
    },
    byline : {
        fontSize: 10,
        color: '#969696',
        fontWeight: 500,
        marginBottom: 20,

        [media.MOBILE]: {
            marginBottom: 0
        }
    },

    uppercase: {
        textTransform: 'uppercase'
    },

    hideOnMobile: {
        [media.MOBILE]: {
            display: 'none'
        }
    }

});




// WEBPACK FOOTER //
// ./react-app-src/pinVideoDetails/styles/pinVideoDetailsStyles.js